/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2019, 2020
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
import React, { Component, Fragment } from 'react';
import { observer } from 'mobx-react';
import { ProgressIndicator } from '@ba/ba-ui-carbon-toolkit';

import PropTypes from 'util/PropTypes';
import StringResources from 'nls/StringResources';
import RECOMMENDATION_PROPERTIES from 'constants/RECOMMENDATION_PROPERTIES';
import VisualizationPreviewList from 'lib/@waca/vis-recommender/src/js/preview/VisualizationPreviewList';
import UnescapedString from 'util/UnescapedString';

import _ from 'underscore';

import './ComparisonRecommendations.scss';

const CLASS_NAME = 'recommended-comparison';


@observer
class ComparisonRecommendations extends Component {

	render() {
		return (
			<div className={CLASS_NAME}>
				<div className={CLASS_NAME + '__title'}>
					{StringResources.get('compareChooser_recommendedComparison_title')}
				</div>
				<div className={CLASS_NAME + '__content'}>
					<div className={CLASS_NAME + '__common'}>
						{this.renderContent()}
					</div>
				</div>
			</div>
		);
	}

	renderContent() {
		const { recommendationVM } = this.props;
		switch(recommendationVM.state) {
			case 'pending':
				return (
					<div className={CLASS_NAME + '__progress-indicator__container'}>
						<ProgressIndicator />
					</div>
				);
			case 'done':
				return this.renderSections();
			case 'error':
				return (
					<div className={CLASS_NAME + '__error__container'}>
						{StringResources.get('error_cannot_load_recommended')}
					</div>
				);
		}
	}

	renderSections() {
		const { recommendationVM } = this.props;
		const recommendations = recommendationVM.getRecommendations();

		const allSectionsEmpty = recommendations.every(recommendation => recommendation.items.length === 0);
		if (allSectionsEmpty) {
			return this.renderEmptyMessage();
		}

		return (
			<Fragment>
				{recommendations
					.map((recommendation, index) => {
						const { items, section } = recommendation;
						if (items.length > 0) {
							return this.renderSection(index, section, items);
						}
					})}
			</Fragment>
		);
	}

	renderEmptyMessage() {
		return (
			<div className={CLASS_NAME + '__empty__list'}>
				{StringResources.get('compareChooser_recommenations_no_recommendations_found')}
			</div>
		);
	}

	renderSection(index, section, items) {

		const headerText = _.escape(section.headerText(items));

		return (
			<div key={index} className={CLASS_NAME + '__section'}>
				<div className = {CLASS_NAME + '__section__header__container'}>
					<div>{StringResources.get('compareChooser_recommendations_headers_columnRelated')}</div>
					<UnescapedString>
						<div className={CLASS_NAME + '__section__header__container__column'}>
							{headerText}
						</div>
					</UnescapedString>
				</div>
				<div className={CLASS_NAME + '__section__body'}>
					{this.renderList(items)}
				</div>
			</div>
		);
	}

	renderList(items) {
		const isNewLayoutEnabled = true;

		return (
			<div className={CLASS_NAME + '__preview-list--horizontal'}>
				<VisualizationPreviewList
					items={items}
					dashboardApi={this.props.dashboardApi}
					onClickItem={this._onClickItem}
					onAddItem={this.props.onItemAdded}
					additionalProperties={RECOMMENDATION_PROPERTIES}
					logger={this.props.logger}
					isNewLayoutEnabled={isNewLayoutEnabled}
					horizontal={true}
					noBottomTitle={true}
					enableSeeMore={false}
					itemSize={'medium'}
					hasFocus={false}
				/>
			</div>
		);
	}

	_onClickItem = (item) => {
		this.props.onItemSelected(item);
	}
}

ComparisonRecommendations.propTypes = {
	dashboardApi: PropTypes.object.isRequired,
	logger: PropTypes.object.isRequired,
	recommendationVM: PropTypes.object.isRequired,
	onItemSelected: PropTypes.func.isRequired,
	onItemAdded: PropTypes.func
};
ComparisonRecommendations.defaultProps = {};

export default ComparisonRecommendations;



// WEBPACK FOOTER //
// ./src/js/components/compareChooser/ComparisonRecommendations.js